
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Artboard – 1","clip-path":"url(#clip-Artboard_1)"}},[_c('path',{attrs:{"data-name":"iconfinder_basics-08_296826 (2) - Outline","d":"M8.432 12.8L3.249 7.445l5.168-5.318L7.221 0 .001 7.444l7.193 7.416z","fill":"#006db6"}})])])
          )
        }
      }
    